import { forwardRef } from 'react';
import type { ComponentPropsWithoutRef, ReactNode } from 'react';

import { AccordionItemContextProvider } from './AccordionItem.context';
import { useAccordionContext } from './Accordion.context';

type AccordionItemProps = {
  children?: ReactNode | ((props: { open: boolean }) => ReactNode);
  className?: string | ((props: { open: boolean }) => string);
  value: string;
} & Omit<ComponentPropsWithoutRef<'div'>, 'children' | 'className'>;

const AccordionItem = forwardRef<HTMLDivElement, AccordionItemProps>(
  ({ children, className, value, ...rest }, ref) => {
    const ctx = useAccordionContext();
    const isActive = ctx.isItemActive(value);

    return (
      <AccordionItemContextProvider value={{ value }}>
        <div
          data-state={isActive ? 'open' : undefined}
          className={typeof className === 'function' ? className({ open: isActive }) : className}
          ref={ref}
          {...rest}
        >
          {typeof children === 'function' ? children({ open: isActive }) : children}
        </div>
      </AccordionItemContextProvider>
    );
  }
);

AccordionItem.displayName = 'AccordionItem';

export { AccordionItem };
export type { AccordionItemProps };
